import React from 'react';
export function EditorAlignRightIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6a1 1 0 011-1h10a1 1 0 110 2H11a1 1 0 01-1-1zM2 10a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM10 14a1 1 0 011-1h10a1 1 0 110 2H11a1 1 0 01-1-1zM2 18a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1z"
  }));
}